module.exports = __webpack_public_path__ + "img/fiscal-consultation.caefd318.png";